import React, { useState, useEffect } from 'react';
import { SponsorContext } from './DataContext';
import axios from "axios"; 
import config from '../components/configuration/config'; 

export const SponsorState = ({ children }) => {
  const [isSponsors, setAllSponsors] = useState([]);
  const [isSponsorsLoading, setSponsorsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sponsors_past_event, setPastEvent] = useState(false);
  const [sponsors_current_event, setCurrentEvent] = useState(false); 
  const [sponsors_categories, setSponsorsCategories] = useState([]);
  
  // Nuevo estado para todos los sponsors sin límite
  const [allSponsorsUnlimited, setAllSponsorsUnlimited] = useState([]);
  const [allSponsorsUnlimitedLoading, setAllSponsorsUnlimitedLoading] = useState(false);
 
 
  
  const apiUrl = 'https://apievt.lacnic.net/wp-json/wp/v2';
  const pageParam = '?per_page=100';

  // Cargar todos los sponsors
  useEffect(() => {
    async function loadSponsors() {
      try {
        setSponsorsLoading(false);
        const sponsors = [];
        
        // Primera llamada para obtener el total de páginas
        const initialResponse = await fetch(`${apiUrl}/sponsors?per_page=100`);
        if (!initialResponse.ok) {
          throw new Error(`Failed to fetch sponsors: ${initialResponse.status} ${initialResponse.statusText}`);
        }
        
        // Obtener el total de páginas desde los headers
        const totalPages = parseInt(initialResponse.headers.get('X-WP-TotalPages')) || 1; 
        
        // Obtener la primera página
        const firstPageSponsors = await initialResponse.json();
        sponsors.push(...firstPageSponsors);
        
        // Obtener las páginas restantes si hay más de una página
        if (totalPages > 1) {
          const remainingPages = [];
          for (let page = 2; page <= totalPages; page++) {
            remainingPages.push(
              fetch(`${apiUrl}/sponsors?per_page=100&page=${page}`)
                .then(response => {
                  if (!response.ok) {
                    throw new Error(`Failed to fetch sponsors for page ${page}: ${response.status} ${response.statusText}`);
                  }
                  return response.json();
                })
            );
          }
          
          // Esperar a que todas las páginas se carguen
          const remainingResults = await Promise.all(remainingPages);
          remainingResults.forEach(pageSponsors => {
            sponsors.push(...pageSponsors);
          });
        } 
        setAllSponsors(sponsors);
        setSponsorsLoading(true);
      } catch (error) {
        console.error('Error loading sponsors:', error);
        setSponsorsLoading(true); // Marcar como cargado incluso si hay error
      }
    }
    loadSponsors();
  }, [apiUrl]);

  // Nuevo useEffect para obtener TODOS los sponsors sin límite
  useEffect(() => {
    async function loadAllSponsorsUnlimited() {
      try {
        setAllSponsorsUnlimitedLoading(true);
        const sponsors = [];
        
        // Primera llamada para obtener el total de páginas
        const initialResponse = await fetch(`${apiUrl}/sponsors?per_page=100`);
        if (!initialResponse.ok) {
          throw new Error(`Failed to fetch sponsors: ${initialResponse.status} ${initialResponse.statusText}`);
        }
        
        // Obtener el total de páginas desde los headers
        const totalPages = parseInt(initialResponse.headers.get('X-WP-TotalPages')) || 1; 
        
        // Obtener la primera página
        const firstPageSponsors = await initialResponse.json();
        sponsors.push(...firstPageSponsors);
        
        // Obtener las páginas restantes si hay más de una página
        if (totalPages > 1) {
          const remainingPages = [];
          for (let page = 2; page <= totalPages; page++) {
            remainingPages.push(
              fetch(`${apiUrl}/sponsors?per_page=100&page=${page}`)
                .then(response => {
                  if (!response.ok) {
                    throw new Error(`Failed to fetch sponsors for page ${page}: ${response.status} ${response.statusText}`);
                  }
                  return response.json();
                })
            );
          }
          
          // Esperar a que todas las páginas se carguen
          const remainingResults = await Promise.all(remainingPages);
          remainingResults.forEach(pageSponsors => {
            sponsors.push(...pageSponsors);
          });
        }
         
        setAllSponsorsUnlimited(sponsors);
      } catch (error) {
        console.error('[UNLIMITED] Error loading sponsors:', error);
      } finally {
        setAllSponsorsUnlimitedLoading(false);
      }
    }
    loadAllSponsorsUnlimited();
  }, [apiUrl]);

    // Cargar sponsors del evento pasado y actual
    useEffect(() => {
      const fetchSponsors = async () => {
        // Solo ejecutar si tenemos los IDs de eventos
        if (config?.currentEventID && config?.pastEventID) {
          setLoading(true);
          try {
            // Parámetros de paginación
            const perPage = 100; // Puedes ajustar este número según necesites
            const params = `${pageParam}&per_page=${perPage}`;
  
            // Fetch sponsors del evento pasado
            const pastResponse = await axios.get(
              `${apiUrl}/sponsors?${params}&our_events=${config?.pastEventID}`
            );
            setPastEvent(pastResponse.data);
  
            // Fetch sponsors del evento actual
            const currentResponse = await axios.get(
              `${apiUrl}/sponsors?${params}&our_events=${config?.currentEventID}`
            );
            setCurrentEvent(currentResponse.data);
          } catch (error) {
            console.error('Error fetching sponsors:', error);
          } finally {
            setLoading(false);
          }
        }
      };
  
      fetchSponsors();
    }, [apiUrl]);
  
  // Cargar categorías de sponsors
  useEffect(() => {
    const fetchCategoriesSponsors = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/category_sponsors${pageParam}`);
        setSponsorsCategories(response.data);
      } catch (error) {
        console.error('Error fetching sponsor categories:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategoriesSponsors();
  }, [apiUrl]);

  return (
    <SponsorContext.Provider value={{
      isSponsors,
      isSponsorsLoading,
      loading, 
      sponsors_current_event,
      sponsors_past_event,
      sponsors_categories, 
      allSponsorsUnlimited,
      allSponsorsUnlimitedLoading
    }}>
      {children}
    </SponsorContext.Provider>
  );
}; 